import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
// import img1 from '../images/img1.jpeg';
// import img2 from '../images/img2.jpeg';
// import img3 from '../images/img3.jpeg';
// import img4 from '../images/img4.jpeg';
// import img5 from '../images/img5.jpeg';
// import img6 from '../images/img6.jpeg';
// import img7 from '../images/img7.jpeg';
// import img8 from '../images/img8.jpeg';
import banner1 from '../images/banner1.jpeg';
import banner2 from '../images/banner2.jpeg';
import banner3 from '../images/banner3.jpeg';
import banner4 from '../images/banner4.jpeg';
import banner5 from '../images/banner5.jpeg';
import banner6 from '../images/banner6.jpeg';
import banner7 from '../images/banner7.jpeg';
import banner8 from '../images/banner8.jpeg';
import banner9 from '../images/banner9.jpeg';
import banner10 from '../images/banner10.jpeg';
import banner11 from '../images/banner11.jpeg';

const useStyle = makeStyles(theme => ({
    banner: {
        margin: '12px 0 12px 0',
        [theme.breakpoints.up('md')]: {
            margin: '84px 0 12px 0',
        },
        width: '100%',
    },
    img: {
        width: '100%',
        maxHeight: 450,
        objectFit: 'cover',
        // borderRadius: 4
    }
}))

const properties = {
    duration: 3000,
    autoplay: true,
    transitionDuration: 500,
    arrows: false,
    infinite: true,
    easing: "ease",
    // indicators: (i) => <div className="indicator">{i + 1}</div>
};

export default function Banner(props) {

    const classes = useStyle();
    const imgArr = [banner7, banner8, banner9, banner10, banner11, banner1, banner2, banner3, banner4, banner5, banner6];

    return (
        <Grid item sm={12} className={classes.banner}>
            <div className="slide-container">
                <Slide {...properties}>
                    {imgArr.map((each, index) => (
                    <div key={index} className="each-slide">
                        <img className={`lazy ${classes.img}`} src={each} alt="sample" />
                    </div>
                ))}
                </Slide>
            </div>
        </Grid>
    )
}